import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useMyEntitlements } from "@seabrookstudios/pitch2table";
import numeral from "numeral";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import { LockedBanner } from "../core/HasEntitlements";

/**
 * Labels for each storage type
 */
const storageLabels = {
  contracts: "Contracts",
  rules: "Rules",
  sellSheets: "Sell Sheets",
  playTestPhotos: "Play Test Photos",
  files: "Files",
};

const n2gb = (n) => n * 1000000000;

export const Storage = () => {
  const { data: entitlements, isLoading } = useMyEntitlements();

  if (isLoading) {
    return (
      <Card elevation={1} square={false}>
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      </Card>
    );
  }

  if (!entitlements) {
    return (
      <Card elevation={1} square={false}>
        <Box p={2} display="flex" justifyContent="center">
          <Typography>An error occurred, please refresh the page.</Typography>
        </Box>
      </Card>
    );
  }

  const usage = entitlements.usage;

  return (
    <Card elevation={1} square={false}>
      <CardHeader title="Data Usage" />
      <CardContent>
        <List>
          {Object.keys(storageLabels).map((key) => {
            const value = usage[key] || 0;
            return (
              <ListItem key={key}>
                <ListItemText primary={storageLabels[key]} />
                <ListItemIcon>{numeral(value).format("0.0 b")}</ListItemIcon>
              </ListItem>
            );
          })}
          <Divider />
          <ListItem>
            <ListItemText primary="Total" />
            <ListItemIcon>{numeral(usage.total || 0).format("0.0 b")}</ListItemIcon>
          </ListItem>
          <ListItem>
            <ListItemText primary="Capacity" />
            <ListItemIcon>{numeral(n2gb(entitlements.totalStorage || 1)).format("0.0 b")}</ListItemIcon>
          </ListItem>
        </List>
        {!entitlements.isMember && <LockedBanner title="Get more space with Premium" />}
      </CardContent>
    </Card>
  );
};
